export const CLINICAL_REPORT_SUMMARY = "CLINICAL_REPORT_SUMMARY";

const careProviderFeatureNamesOf = (careProviderFeaturesAsString) =>
    (typeof careProviderFeaturesAsString === "string" ? careProviderFeaturesAsString : "")
        .split(",")
        .map((careProviderFeatureName) => careProviderFeatureName.trim())
        .filter(Boolean);

export const hasCareProviderFeature = (careProviderFeaturesAsString, careProviderFeature) =>
    careProviderFeatureNamesOf(careProviderFeaturesAsString).includes(careProviderFeature);

export const withCareProviderFeature = (careProviderFeaturesAsString, careProviderFeature, isEnabled) => {
    const otherCareProviderFeatureNames = careProviderFeatureNamesOf(careProviderFeaturesAsString)
        .filter((careProviderFeatureName) => careProviderFeatureName !== careProviderFeature);
    const careProviderFeatureNames = isEnabled
        ? [...otherCareProviderFeatureNames, careProviderFeature]
        : otherCareProviderFeatureNames;
    return careProviderFeatureNames.length > 0 ? careProviderFeatureNames.join(",") : null;
};
